/*
 * @Description 组件  WebrtcPlayer 视频播放器
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div :id="layerId" v-layerDrag="dragPlayer" limit-in-screen>
		<transition name="el-fade-in-linear">
			<!-- web-rtc-palyer start -->
			<div v-show="showPlayerFlag" :class="{'web-rtc-palyer drag-layer-box': true, 'page-marker-intime': intimePageFlag}" :style="{height: intimePageFlag ? plSize_intime.height : plSize.height, width: intimePageFlag ? plSize_intime.width: plSize.width}">
				<!-- header start -->
				<div class="webrtc-palyer-header drag-layer-header" onselectstart="javascript:return false;">
					<span v-if="!intimePageFlag">{{playerMode == 401 ? '试运行' : '视频'}}<span v-if="playerMode == 401" class="palyer-header-vtitle text-over">{{extractRowTitle_401()}}</span></span>
					<!-- 按钮组 start -->
					<div class="player-header-btns">
						<i v-if="false" class="iconfont el-icon-my_zuixiaohua cursor-pointer" title="最小化"></i>
						<i v-if="false" class="iconfont el-icon-my_3zuidahua-3 cursor-pointer"></i>
						<i class="iconfont el-icon-my_guanbi cursor-pointer player-btn-close" title="关闭" @click="closePlayer"></i>
					</div>
					<!-- 按钮组 end -->
				</div>
				<!-- header end -->
				
				<!-- palyer-body start -->
				<div class="webrtc-palyer-body">
					
					<!-- 宫格 start  -->
					<div class="grid-contain-box">
						<!-- 行 start -->
						<div v-for="i in gridFilters.rowNum" :key="i" :class="'grid-contain-row col-items-'+(intimePageFlag ? (gridFilters.rowNum > 1 ? 2 : 1) : (gridFilters.rowNum <=3 ? gridFilters.rowNum : 3))">
							<!-- 列 start -->
							<div v-for="j in gridFilters.colNum" :key="[i, j].join('_')" :class="'grid-contain-col row-items-'+(gridFilters.colNum <= 3 ? gridFilters.colNum : 3)">
								<!-- 内容 start -->
								<div :class="{'grid-contain-item': true, 'grid-item-title-has': inspectRowTitle(gridFilters.colNum*(i-1)+j-1)}" v-if="inspectRow(gridFilters.colNum*(i-1)+j-1)">
									<span class="grid-contain-item-title text-over">{{extractRowTitle(gridFilters.colNum*(i-1)+j-1)}}</span>
									<template v-if="playerMode!=201">
										<SubVideoRTSP :vEleId="['player_vId', i, j].join('_')" :vInfo="dataList[gridFilters.colNum*(i-1)+j-1]" :controls="true" v-if="linkMode == 1"/>
										<SubVideo :vEleId="['player_vId', i, j].join('_')" :vInfo="dataList[gridFilters.colNum*(i-1)+j-1]" :controls="playerMode == 401" v-else/>
									</template>
									<SubVideoJS :vEleId="['player_vId', i, j].join('_')" :vInfo="dataList[gridFilters.colNum*(i-1)+j-1]" :controls="playerMode == 201" v-else/>
								</div>
								<!-- 内容 end -->
							</div>
							<!-- 列 end -->
						</div>
						<!-- 行 end -->
					</div>
					<!-- 宫格 end  -->
					
				</div>
				<!-- palyer-body end -->
			</div>
			<!-- web-rtc-palyer end -->
		</transition>
	</div>
</template>

/* JS */
<script>
	// 组件 播放视频
	import SubVideo from '@/components/SubVideo/SubVideo';
	// 组件 播放视频 rtsp
	import SubVideoRTSP from '@/components/SubVideo/SubVideoRTSP';
	// 组件 播放视频 videoJs
    import SubVideoJS from "../SubVideo/SubVideoJS";
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "WebrtcPlayer",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
            // 组件 播放视频 videoJs
            SubVideoJS,
        	// 组件 播放视频
			SubVideo,
			// 组件 播放视频 rtsp
			SubVideoRTSP,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	/**
			 * @Des layer id
			 * @Auth
			 * @Date 
			 */
			layerId: {
				type: String,
				default: function () {
					return 'layer_id_player-webrtc';
				}
			},// layerId
			
			/**
			 * @Des layer size
			 * @Auth
			 * @Date 
			 */
			layerSize: {
				type: Object,
				default: function () {
					return {height: '400px', width: '600px'};
				}
			},// layerSize
			
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// player尺寸
				plSize: this.layerSize,
				// player尺寸 intime
				plSize_intime: {height: '400px', width: '600px'},
				// 实时页面标志
				intimePageFlag: false,
				
				// 展示 播放器
				showPlayerFlag: false,
				// 参数 宫格
				gridFilters: {
					grid: 1,// 宫格
					rowNum: 1,// 行
					colNum: 1,// 列
				},// gridFilters
				// 最大数量
				maxNum: 9,
				// 数据 list
				dataList: [],
				//{id: 1,rtsp:'rtsp://admin:z455152781@192.168.5.94:554/Streaming/Channels/801'}, {id: 2,rtsp:'rtsp://admin:z455152781@192.168.5.94:554/Streaming/Channels/901'}
				// 数据 key
				dataKeys: [],
				
				// 视频追踪 video
				videoMap_trackIds: {},
				
				// vOption 试运行
				vOption_401: {},
				
				// 播放器模式
				playerMode: 101,// 101 视频追踪	401 试运行
				linkMode: 1,// 地址模式 1、rtsp 2、rtc
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 监听 window resize
			window.addEventListener('resize', this.initLayerPosition, false);
			
			// 初始化 页面标志
			//this.initPageMarker();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 监听 window resize
			window.removeEventListener('resize', this.initLayerPosition, false);
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 初始化 layer position
			 * @Auth
			 * @Date 
			 */
			initLayerPosition() {
				const layerPosition = JSON.parse(this.$store.state.layerPosition);
				const sty = Object.assign({}, layerPosition[this.layerId]);
				// 空值 中止
				if (this.$checkEmpty(sty)) return false;
				
				// 元素
				const el = document.querySelector('#' + this.layerId);
				const layerHeaderEl = el.querySelector('.drag-layer-header');
				const dragDom = el.querySelector('.drag-layer-box');
				
				let l = +sty.left;
				let t = +sty.top;
				
				const elLimit = el.getAttribute('limit-in-screen');
				const layerHeaderElLimit = layerHeaderEl.getAttribute('limit-in-screen');
				const dragDomLimit = dragDom.getAttribute('limit-in-screen');
				// flag 限制 超出视图
				const limitInScreenFlag = (elLimit === '' || elLimit === true) || (layerHeaderElLimit === '' || layerHeaderElLimit === true) || (dragDomLimit === '' || dragDomLimit === true);
				
				if (limitInScreenFlag) {
					// 获取元素宽高
					const dragDomW = dragDom.offsetWidth;
					const dragDomH = dragDom.offsetHeight;
					const layerHeaderElH = layerHeaderEl.offsetHeight;
					
					l = l < 0 ? 0 : l + dragDomW > +document.body.clientWidth ? +document.body.clientWidth - dragDomW : l;
					t = t < 0 ? 0 : t + layerHeaderElH > +document.body.clientHeight ? +document.body.clientHeight - layerHeaderElH : t;
				}
				
				// 移动当前元素  
                dragDom.style.left = `${l}px`;
                dragDom.style.top = `${t}px`;
			},// initLayerPosition
			/**
			 * @Des 拖拽
			 * @Auth
			 * @Date 
			 */
			dragPlayer(oStyle) {
				// 实时页面 中止
				if (this.intimePageFlag) return false;
				
				// 空值 跳过
				if (this.$checkEmpty(oStyle)) return false;
				
				let layerPosition = JSON.parse(this.$store.state.layerPosition);
				layerPosition[this.layerId] = {left: oStyle.left, top: oStyle.top};
				
				// 记录 layer position
				this.$store.dispatch("commitLayerPosition", JSON.stringify(Object.assign({}, layerPosition)));
			},// dragPlayer
			/**
			 * @Des 关闭
			 * @Auth
			 * @Date 
			 */
			closePlayer() {
				
				// 展示 播放器
				this.showPlayerFlag = false;
				
				// 清空数据
				this.cleanDatas();
				
				const jsonData = {code: -1, data: new Date().getTime(), msg: '结束播放'};
				// 视频播器 推送数据
				this.sendPlayerMessage(jsonData);
				
			},// closePlayer
			
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 视频播放器数据
				this.sub_dataChange = this.$pubsub.subscribe('ChangePlayerDate', (name, data) => {
					// 视频播放器数据
					this.changePlayerDate(Object.assign({}, data));
				});// sub_dataChange
			},// startSubscribes
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 视频播放器数据
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},// endSubscribes
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 初始化 页面标志
			 * @Auth
			 * @Date
			 */
			initPageMarker() {
				let path = this.$route.path;
				// 实时页面标志
				this.intimePageFlag = path == '/manager/location/monitor';
				// 实时页面
				if (this.intimePageFlag) {
					// player尺寸 intime
					this.plSize_intime.height = '350px';
					this.plSize_intime.width = '480px';
				}
			},// initPageMarker
			
			/**
			 * @Des 视频播器 推送数据
			 * @Auth
			 * @Date
			 */
			sendPlayerMessage(jsonData) {
				// 空值 跳过
				if (this.$checkEmpty(jsonData)) return false;
				// 发布消息 视频播放器
				this.$pubsub.publish('PlayerOnmessage', Object.assign({}, jsonData));
			},
			
			/**
			 * @Des 视频播放器数据
			 * @Auth
			 * @Date
			 */
			changePlayerDate(data) {
				if (data.code == 'linkstatus') {
					// 链接状态（握手）
					const jsonData = { code: 300, data: new Date().getTime(), msg: '播放器连接成功' };
					// 发布消息 播放器信息
					this.$pubsub.publish('PlayerOnmessage', jsonData);
				} else if (data.code == 'plParams') {
					// 播放器参数
					this.receiveData_plParams(Object.assign({}, data));
				} else if (data.code == 666) {
					// 最大数量
					this.maxNum = [1, 4, 9].indexOf(data.data) != -1 ? data.data : 9;
				} else if (data.code == 101) {
					// 视频追踪
					this.receiveData_101(Object.assign({}, data));
				} else if (data.code == 401) {
					// 试运行
					this.receiveData_401(Object.assign({}, data));
				} else if (data.code == 201) {
                    // 试运行
                    this.receiveData_201(Object.assign({}, data));
                }
			},// changePlayerDate
			
			/**
			 * @Des 接收数据 播放器 参数
			 * @Auth
			 * @Date
			 */
			receiveData_plParams(data) {
				// 空值 跳过
				if (this.$checkEmpty(data)) return false;
				
				if (data.hasOwnProperty('linkMode')) {
					// 地址模式 1、rtsp 2、rtc
					this.linkMode = !this.$checkEmpty(data.linkMode) ? data.linkMode : 1;
				}
				
				if (!this.$checkEmpty(data.plSize)) {
					// 初始化 页面标志
					this.initPageMarker();
					
					const plSize = Object.assign({}, data.plSize);
					// player尺寸
					if (!this.$checkEmpty(plSize.height)) this.plSize.height = parseFloat(plSize.height) + 'px';
					if (!this.$checkEmpty(plSize.width)) this.plSize.width = parseFloat(plSize.width) + 'px';
				}
				
			},// receiveData_plParams
			
			/**
			 * @Des 接收数据 视频追踪
			 * @Auth
			 * @Date
			 */
			receiveData_101(data) {
				// 空值 跳过
				if (this.$checkEmpty(data)) return false;
				// 检索播放器模式
				if (this.playerMode != 101) {
					// 更改播放器模式
					this.changePlayerMode(101);
				}
				
				// 实时页面
				if (!this.intimePageFlag) {
					// 初始化 页面标志
					this.initPageMarker();
				}
				
				const vOption = Object.assign({}, data.data);
				// 空值 跳过
				if (this.$checkEmpty(vOption)) return false;
				
				if (vOption.status == 1) {
					// 打开视频
					this.openVideo_101(vOption);
				} else if (vOption.status == 2) {
					// 暂停视频
					
				} else if (vOption.status == 3) {
					// 继续播放
					
				} else if (vOption.status == 4) {
					// 关闭视频
					
					if (!this.$checkEmpty(vOption.trackId)) {
						// 取消视频
						this.cancelVideo_101(vOption);
					} else {
						// 关闭视频
						this.closePlayer();
					}
				}
			},// receiveData_101
			/**
			 * @Des 视频追踪
			 * @Auth
			 * @Date
			 */
			openVideo_101(data) {
				// 空值 中止
				if (this.$checkEmpty(data.trackId) || this.$checkEmpty(data.vId)) return false;
				
				// 非首页 中止
				if (this.$route.path != '/manager/location/monitor') return false;
				
				let vList = [data.vInfo, ...Object.assign([], data.preList)];
				
				let dataList = Object.assign([], this.dataList);
				let dataKeys = Object.assign([], this.dataKeys);
				
				// 遍历
				vList.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					// 未展示
					if (dataKeys.indexOf(row.vId) == -1) {
						// 数据 datList
						dataList.push(Object.assign({}, row));
						// 数据 key
						dataKeys.push(row.vId);
					}
					
					let trackIds = Object.assign([], this.videoMap_trackIds[row.vId]);
					if (trackIds.indexOf(data.trackId) == -1) {
						trackIds.push(data.trackId);
						this.videoMap_trackIds[row.vId] = Object.assign([], trackIds);
					}
					
				});
				
				this.dataList = Object.assign([], dataList);
				this.dataKeys = Object.assign([], dataKeys);
				
				// 自适应宫格参数
				this.autoGridFilters();
				
				// 空值 关闭播放器
				if (this.dataList.length <= 0) {
					// 展示 播放器
					this.showPlayerFlag = false;
				} else if (!this.showPlayerFlag) {
					// 展示 播放器
					this.showPlayerFlag = true;
					
					// 延迟执行
					this.$nextTick(() => {
						// 初始化 layer position
						this.initLayerPosition();
					});
				}
				
				const jsonData = {code: 111, data: 1, msg: '开始播放', trackId: data.trackId, vId: data.vId, preVid: data.preVid, videoList: data.videoList};
				// 视频播器 推送数据
				this.sendPlayerMessage(jsonData);
			},// openVideo_101
			/**
			 * @Des 取消 视频追踪
			 * @Auth
			 * @Date
			 */
			cancelVideo_101(data) {
				// 空值 中止
				if (this.$checkEmpty(data.trackId)) return false;
				
				const jsonData = {code: 111, data: 4, msg: '结束播放', trackId: data.trackId, vId: data.vId, preVid: data.preVid};
				// 视频播器 推送数据
				this.sendPlayerMessage(jsonData);
				
				// 数据 datList
				let dataList = Object.assign([], this.dataList);
				// 数据 key
				let dataKeys = Object.assign([], this.dataKeys);
				
				let videoMap_trackIds = Object.assign({}, this.videoMap_trackIds);
				
				// 追踪项
				for (let vId in videoMap_trackIds) {
					let trackIds = Object.assign([], videoMap_trackIds[vId]);
					
					let index = trackIds.indexOf(data.trackId);
					if (index != -1) {
						trackIds.splice(index, 1);
					}
					
					// 数值改变
					if (trackIds.length > 0) {
						this.videoMap_trackIds[vId] = Object.assign([], trackIds);
					} else {
						// 移除 video map 项
						delete this.videoMap_trackIds[vId];
						let vIndex = dataKeys.indexOf(vId);
						// 已展示
						if (vIndex != -1) {
							// 数据 datList
							dataList.splice(vIndex, 1);
							// 数据 key
							dataKeys.splice(vIndex, 1);
						}
					}
				}// for in
				
				// 数据 datList
				this.dataList = Object.assign([], dataList);
				// 数据 key
				this.dataKeys = Object.assign([], dataKeys);
				
				// 自适应宫格参数
				this.autoGridFilters();
				
				// 空值 关闭播放器
				if (this.dataList.length <= 0) {
					// 展示 播放器
					this.showPlayerFlag = false;
				}
				
			},// cancelVideo_101
			
			/**
			 * @Des 接收数据 试运行
			 * @Auth
			 * @Date
			 */
			receiveData_401(data) {
				
				let _data = Object.assign({}, data.data);
				// vOption 试运行
				this.vOption_401 = Object.assign({}, _data);
				
				// 空值 跳过
				if (this.$checkEmpty(data)) return false;
				
				// 关闭播放器
				if (_data.status == 4) {
					// 关闭视频
					this.closePlayer();
					return false;
				}
				
				// 空值 跳过
				if (this.$checkEmpty(data.data)) return false;
				// 检索播放器模式
				if (this.playerMode != 401) {
					// 更改播放器模式
					this.changePlayerMode(401);
				}
				
				const vInfo = Object.assign({}, data.data.vInfo);
				this.dataList = [Object.assign({}, vInfo)];
				
				if (!this.showPlayerFlag) {
					// 展示 播放器
					this.showPlayerFlag = true;
					
					// 延迟执行
					this.$nextTick(() => {
						// 初始化 layer position
						this.initLayerPosition();
					});
				}
			},// receiveData_401

            /**
             * @Des 报警视频查看
             * @Auth
             * @Date
             */
            receiveData_201(data) {
                // 空值 中止
                if (data.length == 0) return false;
				
                if (this.playerMode != 201) {
                    this.changePlayerMode(201);
                }
				
                let vList = Object.assign([], data.vList);

                let dataList = Object.assign([], []);
                let dataKeys = Object.assign([], []);

                // 遍历
                vList.forEach((row, index) => {
                    // 空值 跳过
                    if (this.$checkEmpty(row)) return true;

                    // 未展示
                    if (dataKeys.indexOf(row.vId) == -1) {
                        // 数据 datList
                        dataList.push(Object.assign({}, row));
                        // 数据 key
                        dataKeys.push(row.vId);
                    }

                });

                this.dataList = Object.assign([], dataList);
                this.dataKeys = Object.assign([], dataKeys);

                // 自适应宫格参数
                this.autoGridFilters();

                // 空值 关闭播放器
                if (this.dataList.length <= 0) {
                    // 展示 播放器
                    this.showPlayerFlag = false;
                } else if (!this.showPlayerFlag) {
                    // 展示 播放器
                    this.showPlayerFlag = true;

                    // 延迟执行
                    this.$nextTick(() => {
                        // 初始化 layer position
                        this.initLayerPosition();
                    });
                }

            },// openVideo_201

			// ============================================= 基础方法 start =============================================
			/**
			 * @Des 检索 数据
			 * @Auth
			 * @Date
			 */
			inspectRow(index) {
				return !this.$checkEmpty(this.dataList[index]);
			},// inspectRow
			/**
			 * @Des 检索 数据 title
			 * @Auth
			 * @Date
			 */
			inspectRowTitle(index) {
				const row = Object.assign({}, this.dataList[index]);
				return this.playerMode != 401 && !this.$checkEmpty(row) && (!this.$checkEmpty(row.diskChannelName) || !this.$checkEmpty(row.vId));
			},// inspectRowTitle
			/**
			 * @Des 提取 数据 title
			 * @Auth
			 * @Date
			 */
			extractRowTitle(index) {
				const row = Object.assign({}, this.dataList[index]);
				let diskChannelName = !this.$checkEmpty(row.diskChannelName) ? row.diskChannelName : '';
				let vId = !this.$checkEmpty(row.vId) ? row.vId : '';
				return [diskChannelName, (vId ? '（' : ''), vId, (vId ? '）' : '')].join('');
			},// extractRowTitle
			/**
			 * @Des 提取 数据 title 试运行
			 * @Auth
			 * @Date
			 */
			extractRowTitle_401() {
				const row = Object.assign({}, this.vOption_401);
				let title = !this.$checkEmpty(row.title) ? row.title : '';
				let vId = !this.$checkEmpty(row.vId) ? row.vId : '';
				return [title, (vId ? '（' : ''), vId, (vId ? '）' : '')].join('');
			},// extractRowTitle_401
			
			/**
			 * @Des 自适应宫格参数
			 * @Auth
			 * @Date
			 */
			autoGridFilters() {
				// 试运行 中止
				if (this.playerMode == 401) return false;
				
				// 实时页面
				if (this.intimePageFlag) {
					
					// 宫格属性
					this.gridFilters.rowNum = this.dataList.length;
					this.gridFilters.colNum = 1;
					this.gridFilters.grid = this.dataList.length;
					
					// player尺寸 intime
					this.plSize_intime.height = this.dataList.length > 1 ? '660px' : '350px';
					return false;
				}
				
				// 1宫格
				if (this.dataList.length <= 1) {
					// 宫格属性
					this.gridFilters.rowNum = 1;
					this.gridFilters.colNum = 1;
					this.gridFilters.grid = 1;
					
					// player尺寸
					this.plSize.height = '400px';
					return false;
				}
				
				// 2宫格
				if (this.dataList.length <= 2) {
					// 宫格属性
					this.gridFilters.rowNum = 1;
					this.gridFilters.colNum = 2;
					this.gridFilters.grid = 2;
					
					// player尺寸
					this.plSize.height = '260px';
					return false;
				}
				
				// 4宫格
				if (this.dataList.length <= 4) {
					// 宫格属性
					this.gridFilters.rowNum = 2;
					this.gridFilters.colNum = 2;
					this.gridFilters.grid = 4;
					
					// player尺寸
					this.plSize.height = '400px';
					return false;
				}
				
				// 6 9+宫格
				if (this.dataList.length > 4) {
					// 宫格属性
					//this.gridFilters.rowNum = 3;
					this.gridFilters.colNum = 3;
					this.gridFilters.grid = this.dataList.length < 9 ? 6 : 9;
					
					let nums = this.dataList.length;
					// 宫格属性
					this.gridFilters.rowNum = Math.ceil(nums / 3);
					if (this.gridFilters.rowNum > 3) this.gridFilters.rowNum = 3;
					
					// player尺寸
					this.plSize.height = '400px';
					return false;
				}
				
			},// initGridFilters
			/**
			 * @Des 更改播放器模式
			 * @Auth
			 * @Date
			 */
			changePlayerMode(playerMode) {
				// 播放器模式
				this.playerMode = playerMode;// 101 视频追踪	401 试运行
				
				// 101 视频追踪
				if (playerMode == 101 || playerMode == 201) {
					// vOption 试运行
					this.vOption_401 = Object.assign({}, {});
				}
				
				// 401 试运行
				if (playerMode == 401) {
					// 参数 宫格
					this.gridFilters = Object.assign({}, {grid: 1, rowNum: 1, colNum: 1});
				}
				
				// 初始化 页面标志
				this.initPageMarker();
				
			},// changePlayerMode
			/**
			 * @Des 清空数据
			 * @Auth
			 * @Date
			 */
			cleanDatas() {
				// 参数 宫格
				this.gridFilters = Object.assign({}, {grid: 1, rowNum: 1, colNum: 1});
				
				// 最大数量
				this.maxNum = 9;
				// 数据 list
				this.dataList = [];
				// 数据 key
				this.dataKeys = [];
				// 视频追踪 video
				this.videoMap_trackIds = {};
				// 播放器模式
				this.playerMode = 101;// 101 视频追踪	401 试运行
				// vOption 试运行
				this.vOption_401 = {};
			},// cleanDatas
			// ============================================= 基础方法 end =============================================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style src="@/components/WebrtcPlayer/webrtc-player-style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/WebrtcPlayer/WebrtcPlayer.vue